import { Seo } from '@/components/site/seo';
import { ShieldCheck } from 'lucide-react';
import { ForensicForm } from '@/components/site/forms/forensic-form';
import { BannerHero } from '@/components/site/banner-hero';
import { useLocaleContext } from '~/hooks/useLocaleContext';
import { Reveal } from '@/components/site/reveal';

export default function RequestPage() {
  const { locale, dict } = useLocaleContext();

  return (
    <>
      <Seo
        locale={locale}
        title={dict.request.title}
        description={dict.request.subtitle}
        path="/solicitar"
        image="/banners/banner-web-7.jpg"
      />
      <BannerHero
        image="/banners/banner-web-7.jpg"
        title={dict.request.title}
        backHref={`/${locale}`}
        backLabel={dict.common.back}
      />

      <section className="container-tight grid gap-10 py-14 md:grid-cols-[1fr_1.2fr] md:py-20">
        <Reveal className="space-y-4 text-sm leading-relaxed text-muted-foreground">
          <div className="flex items-center gap-2 text-accent">
            <ShieldCheck className="h-5 w-5" />
            <span className="text-xs font-semibold uppercase tracking-[0.18em]">{dict.request.confidential}</span>
          </div>
          <p>{dict.request.confidentialDesc}</p>
          <ul className="mt-6 space-y-2 text-sm text-foreground/80">
            {dict.request.features.map((f, i) => (
              <li key={i}>- {f}</li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={120} className="rounded-2xl border border-border bg-card p-6 md:p-8 shadow-sm">
          <ForensicForm locale={locale} dict={dict} />
        </Reveal>
      </section>
    </>
  );
}
